import { AlkLogger, isNil } from '@alk/core';
import { IStateObject } from '../../interfaces';
import { mergeToObject } from '../../helpers/object-utils';
import { SerializedRecord } from '../../interfaces/functions.interface';
import { StateObjectTransformationCollection } from '../../helpers';

export const serialize = (requested: ReadonlyArray<keyof IStateObject>) => (state: IStateObject): Partial<SerializedRecord<IStateObject>> =>
    requested
        .map(key => ({ [ key ]: JSON.stringify(state[ key ]) }))
        .reduce(mergeToObject);

export const deserialize = (requested: ReadonlyArray<string>) => (state: Partial<SerializedRecord<IStateObject>>): IStateObject =>
    requested.map(
        key => {
            if (isNil(state[ key ])) {
                AlkLogger.info(`[SessionPersistenceService#deserialize] for ${ ''
                }requested keys: ${ key } received undefined value. Will used default value`);
                return {};
            }

            return { [ key ]: StateObjectTransformationCollection[ key ](state[ key ]) };
        },
    ).reduce(mergeToObject, {}) as IStateObject;

export const compareState = <T>(keys: ReadonlyArray<keyof T>) =>
    (prevState: Partial<Record<keyof T, string>>, newState: Partial<Record<keyof T, string>>): boolean =>
        keys.every(key => prevState[ key ] === newState[ key ]);
